import styled from '@emotion/styled';
import { Fonts, Spacings } from '@styles/index';
import Image from '@base/Image';

const StyledMapsLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: ${({ $marginTop }) => $marginTop || Spacings.SPACING_2B};
  padding: 0;
  font-size: 10px;
  font-weight: ${Fonts.HEAVY};
  line-height: 12px;
  letter-spacing: 0.2px;
  text-transform: uppercase;
  color: ${({ $disabled }) =>
    $disabled ? 'var(--color-text-secondary)' : 'var(--color-i-blue)'};
  text-decoration: none;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};

  &:hover {
    text-decoration: ${({ $disabled }) => ($disabled ? 'none' : 'underline')};
  }
`;

const MapsLinkIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  flex-shrink: 0;
`;

const MapsLink = ({ href, marginTop, onClick, showDisabled = false }) => {
  const isDisabled = !href;

  if (!href && !showDisabled) return null;

  return (
    <StyledMapsLink
      href={href || '#'}
      target="_blank"
      rel="noopener noreferrer"
      $marginTop={marginTop}
      $disabled={isDisabled}
      onClick={onClick}
    >
      view on maps
      <MapsLinkIcon>
        <Image
          src="/test-series-revamp/arrow-up-right.svg"
          width={14}
          height={14}
          alt=""
        />
      </MapsLinkIcon>
    </StyledMapsLink>
  );
};

export default MapsLink;
